var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('crud-tag',{attrs:{"embedprops":{
      params: {
        module: _vm.$store.state.route.params.p1,
        action: _vm.$store.state.route.params.p2 || 'list',
        id: _vm.$store.state.route.params.p3 || null
      },
      props: {
        filtro: true,
        gc: true,
        rodape: true,
        paginacao: false,
        titulo: false,
        select: false,
        exportserver: false,
        acoes: true
      }
    }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }